import { z } from "zod";

export const loginSchema = z.object({
  email: z.string().min(1, "Email is required"),
  // password: z.string().min(1, VALIDATION_MESSAGE.get("Password", "required")),
  password: z.string().min(1, "パスワードは必須です。"),
  // remember: z.boolean().optional(),
});
